import {  WMS2040_R01HeaderDto, WMS2040_R01DetailDto  } from "src/containers/mes/WMS/WMS2040_R01/Dto_WMS2040_R01";
import { ResponseDto } from "src/dtos/common/responseDto";
import config from "src/config";
import { getData, putData, patchData, deleteData } from "src/utils/axios/serverHelper";
import { WMS2040_R01Filter } from "./Store_WMS2040_R01";

const baseUrl = `${config.apiUrl}/WMS2040_R01`;

/**
 * 재고 현황 목록 조회 (GET)
 * 재고 테이블과 품목 테이블을 LEFT JOIN하여 재고 현황 정보를 반환
 */
export const getWMS2040_R01List = async (option: string, params: Partial<WMS2040_R01Filter>, listLength: number = 0) => {
	const normalizedOption = option && option.trim().length > 0 ? option : 'search';
	const url = `${baseUrl}/${normalizedOption}`;
  return await getData<ResponseDto<WMS2040_R01HeaderDto[]>>(url, {
    params: {
      ...params,
			listLength
		}
	});
};

export const getWMS2040_R01AllCount = async (params: Partial<WMS2040_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}

/**
 * 재고 원장 목록 조회 (GET)
 * 수불 이력을 조회하여 재고 원장 정보를 반환
 */
export const getDetailWMS2040_R01List = async (params: Partial<WMS2040_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/detail`;
  return await getData<ResponseDto<WMS2040_R01DetailDto[]>>(url, {
    params: {
      	...params,
			listLength
		}
	});
};

/**
 * 수불 이력 엑셀 다운로드 (GET)
 */
export const downloadDetailExcel_WMS2040_R01 = async (option: string, params: Partial<WMS2040_R01Filter>, listLength: number = 0) => {
	const normalizedOption = option && option.trim().length > 0 ? option : 'search';
	const url = `${baseUrl}/excel/${normalizedOption}`;
	
	return await getData<ResponseDto<ArrayBuffer>>(url, {
		params: {
			...params,
			listLength
		}
	});
}; 
